import { ManufacturingDatalistInput } from "@/components/manufacturing/ManufacturingDatalistInput";
import { inputClass } from "@/components/manufacturing/manufacturingSurfaceClasses";

export function MaterialModalShippingFields(props: {
  unit: string;
  shippingUnit: string;
  shippingUnitOptions: readonly string[];
  onShippingUnitChange: (v: string) => void;
  shippingWeight: string;
  onShippingWeightChange: (v: string) => void;
  piecesPerShippingUnit: string;
  onPiecesPerShippingUnitChange: (v: string) => void;
}) {
  const unitLabel = props.unit.trim() || "pieces";
  const shipLabel = props.shippingUnit.trim() || "shipping unit";
  return (
    <>
      <div className="grid grid-cols-2 gap-2">
        <label className="block text-xs text-gray-600 dark:text-zinc-300">
          Shipping unit
          <ManufacturingDatalistInput
            className="mt-1"
            placeholder="bundle / pallet / each"
            value={props.shippingUnit}
            options={props.shippingUnitOptions}
            onChange={props.onShippingUnitChange}
          />
        </label>
        <label className="block text-xs text-gray-600 dark:text-zinc-300">
          Shipping weight (lbs)
          <input
            className={`${inputClass} mt-1`}
            inputMode="decimal"
            placeholder="0"
            value={props.shippingWeight}
            onChange={(e) => props.onShippingWeightChange(e.target.value)}
          />
        </label>
      </div>
      <label className="block text-xs text-gray-600 dark:text-zinc-300">
        Pieces per shipping unit
        <input
          className={`${inputClass} mt-1`}
          inputMode="decimal"
          placeholder="1"
          value={props.piecesPerShippingUnit}
          onChange={(e) => props.onPiecesPerShippingUnitChange(e.target.value)}
        />
        <span className="mt-1 block text-[11px] text-gray-500 dark:text-zinc-400">
          How many {unitLabel} in one {shipLabel}. Defaults to 1 when shipping unit matches the piece
          unit.
        </span>
      </label>
    </>
  );
}
